import React from 'react';
import { Typography, Box } from '@mui/material';
import { Email as EmailIcon, Phone as PhoneIcon } from '@mui/icons-material';

const ContactCell = ({ 
  name, 
  email, 
  phone = null, 
  nameVariant = 'body2', 
  contactVariant = 'caption' 
}) => {
  return (
    <Box>
      <Typography variant={nameVariant} fontWeight="medium">
        {name}
      </Typography>
      {email && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
          <EmailIcon fontSize="small" sx={{ color: 'primary.main', fontSize: 16 }} />
          <Typography variant={contactVariant} color="text.secondary">
            {email}
          </Typography>
        </Box>
      )}
      {phone && phone !== null && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <PhoneIcon fontSize="small" sx={{ color: 'primary.main', fontSize: 16 }} />
          <Typography variant={contactVariant} color="text.secondary">
            {phone}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ContactCell; 